import {
  Typography,
  styled,
  Box,
  TextField,
  CircularProgress,
  Backdrop,
  Button
} from '@mui/material'

import { useState } from 'react'
import { useDispatch } from 'react-redux'
import {
  getAllOrganizations,
  getOrganizationWithCUIT
} from '../../../redux/actions/Organizations'
import useStyles from './useStyles'
import { getAllSuborganizations } from '../../../redux/actions/Suborganizations'
// import { Route, Routes } from 'react-router-dom'
// import InstancesOrg from '../../Organizations/Instances/InstancesOrg'

const BoxRoot = styled(Box)(() => ({
  width: '100%',
  marginLeft: '2%'
}))

const InputContainer = styled(Box)(() => ({
  width: '30rem',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignContent: 'center',
  gap: '1.5rem',
  // top
  padding: '5% 0% 0% 5%',
  '@media all and (max-width: 700px)': {
    width: '80%'
  }
}))
const BoxInput = styled(Box)(() => ({
  width: '30rem',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignContent: 'center',
  gap: '1.5rem',
  color: '#4B4952',
  fontSize: 18,
  fontFamily: 'roboto',
  '@media all and (max-width: 700px)': {
    width: '100%'
  }
}))
const InputButton = styled(Button)(() => ({
  background: '#1C846F',
  '&:hover': {
    background: '#0CABA8'
  },
  borderRadius: '5rem',
  color: '#fff'
}))

const InputButtonDisabled = styled(Button)(() => ({
  background: '#9ca19d',

  borderRadius: '5rem',
  color: '#fff'
}))

export const SearchCuit = ({ setValueFilter }) => {
  const valoresAceptados = /^[0-9]+$/
  const [CUIT, setCUIT] = useState('')
  const [showCircularProgress, setShowCircularProgress] = useState(false)
  const [error, seterror] = useState(false)
  const [errorText, seterrorText] = useState('')
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(false)
  const classes = useStyles()

  const validateCUIT = (number) => {
    const valoresAceptados = /^[0-9]+$/
    return !!(number.match(valoresAceptados) && number.length === 11)
  }

  const handleClose = () => {}
  const handleChange = (e) => {
    setCUIT(e.target.value)

    if (e.target.value !== '') {
      if (
        !e.target.value.match(valoresAceptados) ||
        e.target.value.length > 11
      ) {
        seterrorText('El CUIT debe contener 11 números, sin guiones')
        seterror(true)
      } else {
        seterror(false)
      }
    } else {
      seterror(false)
    }
  }

  const handleGetOrgsCandidates = async () => {
    const param = {
      organizationCuit: CUIT
    }
    try {
      const response = await dispatch(getAllOrganizations(param))
      const orgId = response[0]?.organizationId || null
      if (orgId) {
        const suborganizations = await dispatch(getAllSuborganizations(orgId))
        !suborganizations || !suborganizations[0]
          ? seterrorText('No se encontraron estudios activos asociados al CUIT ingresado')
          : window.location.href = `/ME/declarations/${suborganizations[0].suborganizationId}/declarations`
      } else {
        console.log('Organización no encontrada.')
      }

      setValueFilter(CUIT)

      handleClose()
    } catch (error) {
      console.log(error)
    }
  }

  const isExists = async () => {
    setLoading(true)
    setShowCircularProgress(true)
    const response = await dispatch(getOrganizationWithCUIT(CUIT))
    if (response === 'Organization not found') {
      seterrorText('No existe una organización con el CUIT ingresado')
      seterror(true)
      setLoading(false)
      setShowCircularProgress(false)
      return
    }
    await handleGetOrgsCandidates()
    setLoading(false)
    setShowCircularProgress(false)
  }

  const handleSearchSubmit = async (event) => {
    if (
      event.type === 'keydown' &&
      event.key === 'Enter' &&
      validateCUIT(CUIT)
    ) {
      await isExists()
    }
  }

  return (
    <div className={classes.root}>
      <BoxRoot>
        <Backdrop
          sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={loading}
        >
          <CircularProgress color="inherit" />
        </Backdrop>

        <InputContainer>
          <BoxInput>
            <div style={{ fontWeight: 'lighter' }}>Ingrese el CUIT de la Organización</div>
          </BoxInput>
          <TextField
            sx={{ width: '100%' }}
            autoFocus
            id="name"
            type="text"
            value={CUIT}
            onChange={handleChange}
            onKeyDown={handleSearchSubmit}
            placeholder={'Ej: 30582622945'}
            error={error}
            helperText={error ? errorText : ''}
          />

          {validateCUIT(CUIT)
            ? (
            <ButtonConfirm
              isExists={isExists}
              showCircularProgress={showCircularProgress}
            />
              )
            : (
            <ButtonConfirmDisabled />
              )}
        </InputContainer>
      </BoxRoot>
    </div>
  )
}

function ButtonConfirm ({ isExists, showCircularProgress }) {
  return (
    <InputButton onClick={isExists}>
      {showCircularProgress
        ? (
        <CircularProgress size="1.5rem" color="inherit" />
          )
        : (
        <Typography>BUSCAR</Typography>
          )}
    </InputButton>
  )
}

function ButtonConfirmDisabled () {
  return (
    <InputButtonDisabled style={{ pointerEvents: 'none' }}>
      <Typography>BUSCAR</Typography>
    </InputButtonDisabled>
  )
}
